import styled from "styled-components";
import { Div } from "components";

export const Wrapper = styled(Div)`
  padding-top: 8px;
  padding-left: 16px;
  padding-right: 16px;

  .highcharts-title {
    font-weight: 600;
  }
`;
